import { render, staticRenderFns } from "./SuppressPortsPopup.vue?vue&type=template&id=763fed68&scoped=true"
import script from "./SuppressPortsPopup.vue?vue&type=script&lang=js"
export * from "./SuppressPortsPopup.vue?vue&type=script&lang=js"
import style0 from "./SuppressPortsPopup.vue?vue&type=style&index=0&id=763fed68&prod&lang=scss"
import style1 from "./SuppressPortsPopup.vue?vue&type=style&index=1&id=763fed68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763fed68",
  null
  
)

export default component.exports